import { LuCopy, LuCopyCheck } from "react-icons/lu";
import { Sheet } from "react-modal-sheet";

import { useCopyToClipboard } from "shared/hooks/use-copy-to-clipboard";
import { Button } from "shared/ui/button";
import { Img } from "shared/ui/img";
import { TextGradient } from "shared/ui/text-gradient";

import sheetBg from "./assets/sheet-bg.png";
import sheetPicture from "./assets/sheet-picture.svg";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const InviteSheet = (props: Props) => {
  const { isOpen, onClose } = props;

  const { copy, isCopied } = useCopyToClipboard();

  return (
    <Sheet
      className="relative"
      detent="content"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className="flex flex-col items-center">
            <Img
              className="mt-8 h-28 w-[106px]"
              src={sheetPicture}
              alt="Invite Friends"
            />
            <img
              src={sheetBg}
              className="absolute top-1/2 left-1/2 -z-10 -translate-x-1/2 -translate-y-1/2"
            />
            <h2 className="text-center text-2xl font-semibold">
              Farm more with your <br /> Friends!
            </h2>

            <div className="mt-8 flex gap-x-2 font-semibold">
              <TextGradient className="persian-orange-gradient text-5xl">
                23
              </TextGradient>
              <div className="text-persianOrange uppercase">
                friends <br /> referred
              </div>
            </div>

            <div className="mt-5 text-lg">Referral Rewards Earned </div>
            <div className="text-balticSea mb-8 text-xl font-semibold">
              2,350.55
            </div>
            <Button className="mt-auto w-full max-w-[300px]">
              Invite more
            </Button>
            <button
              className="text-balticSea mt-3.5 mb-11 flex cursor-pointer items-center gap-x-2 font-medium outline-hidden active:brightness-125"
              onClick={async () => {
                await copy("Text value");
              }}
            >
              {isCopied && <LuCopyCheck className="size-4.5" />}
              {!isCopied && <LuCopy className="size-4.5" />}
              Copy invite link
            </button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};
